import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleProductMonthlyRating(context, searchItem) {
            let url = "sale_product_monthly_ratings?page="  + searchItem.page

            if (!context.state.saleProductMonthlyRating.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleProductMonthlyRating', data)
                })
                .catch((err) => {
                    console.log(err)

                })
        },
    },
    mutations: {
        updateSaleProductMonthlyRating(state, data) {
            state.saleProductMonthlyRating = data
            state.saleProductMonthlyRating.isNeedFetch = false
        },
    },
    state: {
        saleProductMonthlyRating: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleProductMonthlyRating(state) {
            return state.saleProductMonthlyRating.models
        },
        getSaleProductMonthlyRatingTotalCount(state) {
            return state.saleProductMonthlyRating.totalItems
        },
    },
}
